import React from "react";
import { Box, Typography, Button, List, ListItem, Divider } from "@mui/material";

const ONE_TIME_FEE = 1250.0;
const MONTHLY_FEE = 20.0;

const PaymentStep = ({
    paymentUrl,
    eans
}) => {
    const totalOneTime = ONE_TIME_FEE * eans.length;
    const totalMonthly = MONTHLY_FEE * eans.length;

    return (
        <Box sx={{ mt: 4, maxWidth: 500, mx: "auto" }}>
            <Typography variant="h5" gutterBottom>
                Checkout Overview
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
                You are about to pay for the following EANs:
            </Typography>
            <List sx={{ mb: 2 }}>
                {eans.map((ean, idx) => (
                    <ListItem
                        key={idx}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            border: "1px solid #eee",
                            borderRadius: 2,
                            mb: 1,
                            py: 1.5,
                            px: 2,
                            background: "#fafafa"
                        }}
                    >
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            {ean}
                        </Typography>
                        <Typography variant="body2">
                            One-time fee: <strong>€ {ONE_TIME_FEE.toFixed(2)}</strong>
                        </Typography>
                        <Typography variant="body2">
                            Monthly fee: <strong>€ {MONTHLY_FEE.toFixed(2)}</strong>
                        </Typography>
                    </ListItem>
                ))}
            </List>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ textAlign: "right", mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Total one-time fee: € {totalOneTime.toFixed(2)}
                </Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Total monthly fee: € {totalMonthly.toFixed(2)}
                </Typography>
            </Box>
            <Button
                variant="contained"
                color="primary"
                href={paymentUrl}
                target="_blank"
                rel="noopener"
                sx={{ mt: 2, width: "100%" }}
            >
                Proceed to Payment
            </Button>
        </Box>
    );
};

export default PaymentStep;